// extracted by mini-css-extract-plugin
export default {"section-title":"style_section-title__aqgLc"};